<template>
  <h2 class="pb-2 border-bottom">Weight Loss Medications</h2>
  <div class="wl-flex">
    <div class="wl-content">
      <ul>
    <li>Tirzepatide (Mounjaro, Zepbound) – Dual GIP/GLP-1 agonist, shown to be even more effective for weight loss</li>
    <li>Liraglutide (Saxenda) – Daily injection, an alternative for patients who prefer non-weekly dosing</li>
  </ul>
  <p>💡 Patients can lose 10-20% of their body weight with these medications when combined with lifestyle changes.</p>

  <h5>Weight Loss Program Structure</h5>
  <ul>
    <li>Initial Consultation & Evaluation
      <ul>
        <li>Comprehensive medical history & weight assessment</li>
        <li>Personalized weight loss plan based on goals & health conditions</li>
      </ul>
    </li>
    <li>GLP-1 Medication Plan
      <ul>
        <li>Custom dosing schedule based on patient needs</li>
        <li>Guidance on side effects & how to manage nausea</li>
        <li>Ongoing monitoring & dose adjustments</li>
      </ul>
    </li>
    <li>Nutrition & Lifestyle Coaching
      <ul>
        <li>Meal planning & portion control guidance</li>
      </ul>
    </li>
    <li>Monthly Check-ins & Progress Tracking via text message</li>
  </ul>
    </div>
    <div class="wl-videos">
      <iframe width="320" height="568" style="max-width:100%; border-radius: 12px; box-shadow: 0 4px 24px rgba(0,0,0,0.08); margin-bottom: 1.5rem;" src="https://www.youtube.com/embed/L1P7TDXi-3g" title="YouTube Shorts: Weight Loss 1" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe>
      <iframe width="320" height="568" style="max-width:100%; border-radius: 12px; box-shadow: 0 4px 24px rgba(0,0,0,0.08);" src="https://www.youtube.com/embed/VVgrgvhakKY" title="YouTube Shorts: Weight Loss 2" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe>
    </div>
  </div>
</template>

<script>
export default {
  name: 'WeightLossContentEn'
};
</script>

<style scoped>
.wl-flex {
  display: flex;
  gap: 2rem;
  flex-wrap: wrap;
  align-items: flex-start;
  margin-top: 1.5rem;
}
.wl-content {
  flex: 1 1 340px;
  min-width: 0;
}
.wl-videos {
  flex: 0 0 340px;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
}
@media (max-width: 900px) {
  .wl-flex {
    flex-direction: column;
    gap: 1.5rem;
  }
  .wl-videos {
    flex-direction: row;
    justify-content: flex-start;
    align-items: flex-start;
    margin: 0 auto;
    gap: 1rem;
  }
  .wl-videos iframe {
    width: 48vw;
    height: 270px;
    min-width: 160px;
    max-width: 100%;
  }
}
</style>
